import { apiGet } from "../../api/apiClient";

class SubscriberGrowthActions {
  static getSubscriberGrowth = async (locationId) => {
    return await apiGet(`/subscriber-growth/location/${locationId}`);
  };
}

export default SubscriberGrowthActions;
